"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDescribers = void 0;
var react_1 = require("react");
var useDescribers = function (_a) {
    var help = _a.help, uniqueId = _a.uniqueId, guidance = _a.guidance;
    return (0, react_1.useMemo)(function () {
        if (uniqueId && (help || guidance)) {
            return "".concat(help ? uniqueId + '-help' : '', " ").concat(guidance ? uniqueId + '-guidance' : '');
        }
        return undefined;
    }, [guidance, help, uniqueId]);
};
exports.useDescribers = useDescribers;
